<template>
  <div
    :id="id_name"
    @click="generate_excel">
    <slot>
      {{button_text}}{{ajaxGetKey}}
    </slot>
  </div>
</template>

<script>
  import { Api } from '@/api/commissionEnv'
  import { getTimeDiff,updateTimeByUtc } from 'common/js/util'
  var api = new Api()

  export default {
    data () {
      return {
        UTCDIFF: getTimeDiff(),
        meta: [],
        data: []
        // keys: {}
      }
    },
    props: {
      multiLanguage: {  
        type: Object,
        default: {}
      },
      button_text: {
        type: String,
        default: "Download Excel"
      },
      name: {
        type: String,
        default: "data.xlsx"
      },
      keys: {
        default: Array
      },
      ajaxUrl: {
        default: false
      },
      label: {
        default: false
      },
      ajaxGetKey: {
        default: false
      },
      ajaxPar: {
        default: {}
      },
      ajaxType: {
        default: "get"
      },
      colData: {
        default: false
      },
      mainAcc: {
        default: '',
      },
      reqData: {
        default: false
      }
    },
    mounted () {
    },
    computed: {
      id_name () {
        var now = new Date().getTime()
        return "export_" + now
      },
      // getIBInfoUrl () {
      //   if ( this.region == "GM" ) api.switchGMPort()
      //   if ( this.region == "UK" ) api.switchUKPort()
      //   return api.getUrl('getIBInfo')
      // }
    },
    methods: {
      emitXmlHeader: function () {
        var headerRow = "<tr>\n"
        // for (var colName in this.keys) {
        //   headerRow += "  <th style="text-align: left;">\n";
        //   headerRow += colName + "\n";
        //   headerRow += "  </th>\n";
        // }
        this.keys.forEach((item) => {
          headerRow += "  <th style='text-align: left;'>\n"
          headerRow += item + "\n"
          headerRow += "  </th>\n"
        })

        headerRow += "</tr>\n"
        // var metatags = null
        // this.meta.forEach(function (element) {
        //   metatags += "<meta "
        //   element.forEach(function (m) {
        //     metatags += m.key + "='" + m.value + "' "
        //   })
        //   metatags += ">"
        // })
        return "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'><head>"+"<meta http-equiv='Content-Type' content='text/html; charset=utf-8'>" + "<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Data</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>\n" +
          "<thead>\n\n" +
          headerRow +
          "</thead>\n\n" +
          "</tbody>\n"
      },
      emitXmlFooter () {
        return "\n</tbody>\n" +
          "</table>\n" +
          "</body>\n" +
          "</html>\n"
      },
      jsonToHtml: function (jsonObject) {
        var row = null
        var col = null
        var xml = null
        var data = typeof jsonObject !== "object"
          ? JSON.parse(jsonObject)
          : jsonObject
        xml = this.emitXmlHeader()
        // console.log(JSON.stringify(data))
        for (row = 0; row < data.length; row++) {
          xml += "<tr>\n"

          for (col in data[row]) {
            xml += "  <td style='text-align: left;'>\n"
            xml += (String(data[row][col]) ? String(data[row][col]) : "") + "\n"
            xml += "  </td>\n"
          }
          xml += "</tr>\n"
        }
        xml += this.emitXmlFooter()
        return xml
      },
      generate_excel () {
        var uri = "data:application/vnd.ms-excel;base64,"
        var base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
        if (this.ajaxUrl) {
          let ajaxPar = this.ajaxType === "post" ? this.ajaxPar : {params: this.ajaxPar,headers:{UTCDIFF: this.UTCDIFF}}
          this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then((res) => {
            if ( this.label == 'getSalesInfo'){
              let result = res.data.data.sales_info
              let formatData = []
              result.forEach(element => {
                formatData.push(
                  {
                    sales_id: element.sales_id,
                    acc_name: element.acc_name,
                    phone: element.phone,
                    email: element.email,
                    remark: element.remark,
                    officeState: this.multiLanguage.th.employeeState[element.officeState], 
                    last_update: updateTimeByUtc(this.UTCDIFF,element.last_update),
                    status: element.status == 0 ? this.multiLanguage.isSetting.unsated : element.status == 1 ? this.multiLanguage.isSetting.unchecked : this.multiLanguage.isSetting.checked,
                  }
                )
              })
              this.data = formatData
              var href = uri + base64(this.jsonToHtml(this.data))
              window.location.href = href
            }
            else if (this.label == 'allCommissionReport'){
              let data = res.data.data.data
              let arr = []
              data.forEach(item => {
                  item.internalCommissionReturn = ''
                  item.cpaCommissionReturn = ''
                  for (let code of item.first){
                    item.internalCommissionReturn += code + ' ' + this.multiLanguage.unit + ' / '
                  }
                  for (let code of item.cpa) {
                    item.cpaCommissionReturn += code + ' ' + this.multiLanguage.unit + ' / '
                  }
                  let obj = {}
                  obj['type'] = this.multiLanguage[item.type]
                  obj['account'] = item.ibId
                  obj['name'] = item.name
                  obj['commissionReturn'] = 
                    item.mode == 1 ? this.multiLanguage.CPACommission + ' : ' + item.cpaCommissionReturn : 
                    item.mode == 0 ? this.multiLanguage.internalCommission + ' : ' + item.internalCommissionReturn : item.mode == 2 ? 
                    this.multiLanguage.internalCommission + ' : ' + item.internalCommissionReturn + ' + ' + 
                    this.multiLanguage.CPACommission + ' : ' + item.cpaCommissionReturn : ''
                  arr.push(obj)
              })
              this.data = arr
              var href = uri + base64(this.jsonToHtml(this.data))
              window.location.href = href
            }
            else { // salesCommissionSettingPreview
              let arr = []
              res.data.data.data.forEach(item => {
                let obj = {}
                obj['mainAcc'] = this.mainAcc
                obj['subordinateType'] = this.multiLanguage.type[item.type]
                obj['subordinateAccount'] = item.account
                obj['subordinateName'] = item.name
                obj['relationType'] = this.multiLanguage.relationType[item.relationType]
                obj['condition'] = ''
                for (let val of item.condition) {
                  obj['condition'] += (val.clientType == 1 ? this.multiLanguage.clientType.IBClient : val.clientType == 2 ? this.multiLanguage.clientType.directClient : '') + ' '
                  for (let d of this.reqData) {
                    if (val.ruleId == d.ruleId) {
                      obj['condition'] += this.multiLanguage.rule[d.langKey.split('.')[1]] + ' : '
                      obj['condition'] += val.value + ';'
                    }
                  }
                }
                arr.push(obj)
              })
              this.data = arr
              var href = uri + base64(this.jsonToHtml(this.data))
              // a.href = href
              // a.download = this.name;
              window.location.href = href
            }
          })
        } else if (this.colData) {
          this.data = this.colData
          var href = uri + base64(this.jsonToHtml(this.data))
          window.location.href = href
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// commissionJsonExcel.vue?22e09774